<template>
	<div class="sms-manager">
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="短信群发" name="first">
				<!-- <el-tabs v-model="activeNames" @tab-click="handleClicks">
					<el-tab-pane label="模板短信" name="first">
						
					</el-tab-pane>
					<el-tab-pane label="自定义短信" name="second">
						
					</el-tab-pane>
				</el-tabs> -->
				<div class=""
					style="display: flex;justify-content: space-between;width: 100%;height: 60.4vh;overflow-y: auto;">
					<div class="" style="width: 50%;">
						<el-form ref="formss" :model="form" :rules="formRuless" label-width="100px">
							<el-form-item label="目标筛选">
								<div class="" style="display: flex;align-items: center;justify-content: space-between;">
									<div class="" style="width: 32.33%;">
										<el-select style="width: 100%;" v-model="form.test" placeholder="是否测试"
											clearable>
											<el-option label="是" value="shanghai"></el-option>
											<el-option label="否" value="beijing"></el-option>
										</el-select>
									</div>
									<div class="" style="width: 32.33%;">
										<el-select style="width: 100%;" v-model="form.signIn" placeholder="是否签到"
											clearable>
											<el-option label="是" value="shanghai"></el-option>
											<el-option label="否" value="beijing"></el-option>
										</el-select>
									</div>
									<div class="" style="width: 32.33%;">
										<el-select style="width: 100%;" v-model="form.grouping" placeholder="类型/分组"
											clearable>
											<el-option v-for="(item,index) in meetingVoteData" :label="item.groupName"
												:value="item.groupId"></el-option>
										</el-select>
									</div>
								</div>
								<div class=""
									style="display: flex;justify-content: space-between;width: 100%;margin-top: 10px;">
									<div class="" style="width: 49%;">
										<el-select style="width: 100%;" v-model="form.voteId" placeholder="表决事项"
											clearable @change="voteIdChange" @clear="voteIdClear">
											<el-option v-for="(item,index) in voteList" :label="item.name"
												:value="item.id"></el-option>
										</el-select>
									</div>
									<div class="" style="width: 49%;">
										<el-select style="width: 100%;" v-model="form.optionId" placeholder="表决选项"
											clearable no-data-text="请选择表决事项">
											<el-option v-for="(item,index) in voteOptions" :label="item.name"
												:value="item.id"></el-option>
										</el-select>
									</div>
								</div>
							</el-form-item>
							<el-form-item label="模板选择" prop="meetingLianluMsg" clearable>
								<!-- {{meetingLianluMsgList}} -->
								<div @click.stop="employClick(item)" v-for="(item,index) in meetingLianluMsgList"
									class=""
									style="width: 100%;padding: 10px;border-radius: 4px;margin-bottom: 20px;cursor:default;"
									:style="item.id == form.meetingLianluMsg.id?'border: 1px solid #2766ff;':'border: 1px solid #CCCCCC;'">
									<div class=""
										style="width: 100%;display: flex;align-items: center;justify-content: space-between;">
										<div class="" style="display: flex;align-items: center;">
											<div class=""
												:style="item.id == form.meetingLianluMsg.id?'background-color: #2766ff;width: 16px;height: 16px;':'background-color: #FFFFFF;border: 1px solid #CCCCCC;width: 14px;height: 14px;'"
												style="border-radius: 50%;display: flex;align-items: center;justify-content: center;">
												<div class=""
													style="width: 6px;height: 6px;border-radius: 50%;background-color: #FFFFFF;">

												</div>
											</div>
											<div class=""
												style="font-size: 12px;color: #282D30;font-weight: 700;margin-left: 5px;line-height: 16px;">
												{{item.name}}
											</div>
										</div>
										<div class="" style="display: inline;">
											<div @click.stop="editSms(item)" class=""
												style="font-size: 12px;color: #3772DE;border: 1px solid rgba(55,114,222,0.4);border-radius: 3px;padding: 4px 6px;line-height: 16px;">
												参数配置
											</div>
										</div>

									</div>
									<div class=""
										style="width: 100%;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 6;-webkit-box-orient: vertical;">
										{{item.content}}
									</div>
								</div>

								<!-- <div class="" style="width: 100%;display: flex;align-items: center;">
									<div v-if="form.meetingLianluMsg.name!=''" class=""
										style="margin-right: 5px;">
										{{form.meetingLianluMsg.name}}
									</div>
									<el-button @click="templateDialogVisibleClick"
										style="border-color: #3772DE;color:#3772DE;">选择模板</el-button>
								</div> -->
							</el-form-item>

							<el-form-item label="发送统计">
								<div class="balloon-left">
									短信余额{{noteBalance}}条
								</div>
								<!-- <div class="" style="display: flex;">
									<div class="">
										（短信可用余额{{noteBalance}}条）
									</div>
								</div> -->

							</el-form-item>

							<el-form-item>
								<el-button style="width: 180px;height: 40px;" size="medium" type="primary"
									@click="onSubmits" :loading="onSubmitsLoading">提交发送</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="" style="width: 50%;">
						<div class="" style="display: flex;justify-content: center;width: 100%;">
							<div class=""
								style="width: 300px;height: 540px;display: flex;align-items: center;justify-content: center;border-radius: 25px;background-color: #DDDDDD;">
								<div class=""
									style="width: 280px;height: 500px;background-color: #FFFFFF;border-radius: 10px;">
									<div class="chatBox chatBox-left"
										style="font-size: 14px;color: #333333;line-height: 20px;">
										【释参信息】{{form.content}}
									</div>
								</div>
							</div>
						</div>
						<div class=""
							style="width: 100%;text-align: center;font-size: 14px;color: #333333;margin-top: 20px;">
							短信演示效果
						</div>


					</div>
				</div>
			</el-tab-pane>
			<!-- <el-dialog class="ss" title="短信模板列表" :close-on-click-modal="false" :visible.sync="templateDialogVisible"
				width="65%" :center="false" append-to-body custom-class="customClass" top="30vh">
				<div class="" style="">
					<el-table ref="multipleTable4" :data="meetingLianluMsgList" size="medium" v-loading="loading"
						height="38.1vh" class="sms-table">
						<el-table-column prop="serialNumber" label="序号" align="center" width="50px"></el-table-column>
						<el-table-column min-width="150px" prop="name" label="标题" align="center" width="150px">
						</el-table-column>
						<el-table-column prop="content" label="内容" align="center" min-width="40%"></el-table-column>
						<el-table-column fixed="right" label="操作" align="center" width="200px">
							<template slot-scope="scope">
								<el-button @click="employClick(scope.row)" type="text">使用此模板</el-button>
								<el-button @click="editSms(scope.row)" type="text">配置参数</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-dialog> -->
			<el-dialog :title="centerDialogVisibleType == '1'?'输入号码详情':'文件导入详情'" :close-on-click-modal="false"
				:visible.sync="centerDialogVisibles" width="50%" :center="false" append-to-body>
				<!-- <div class="" style="display: flex;align-items: center;">
					<el-input style="width: 270px;" clearable
						placeholder="请输入手机号" v-model="keyword"></el-input>
					<el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="centerDialogVisibleOnSearch">查询</el-button>
				</div> -->
				<div class="" style="margin-top: 10px;">
					<el-table ref="multipleTable4" :data="phoneList" size="medium" v-loading="loading" height="41.8vh"
						class="sms-table">
						<el-table-column min-width="150px" prop="name" label="手机号" align="center"></el-table-column>
						<el-table-column min-width="150px" label="数据来源" align="center">
							<template slot-scope="scope">
								{{centerDialogVisibleType == '1'?'手动输入':'文件导入'}}
							</template>
						</el-table-column>
						<el-table-column width="150px" fixed="right" label="操作" align="center">
							<template slot-scope="scope">
								<el-button type="text" @click.stop="deletePhone(scope.$index)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
					<Pagination :total="phoneListNumber" @handleSizeChange="phoneListTurnPage"
						@handleCurrentChange="phoneListTurnPage" customClass="alone" />
					</Pagination>
				</div>
				<!-- <div class="flex align-center justify-center">
					<span slot="footer" class="dialog-footer">
						<el-button @click="centerDialogVisible = false">取 消</el-button>
						<el-button type="primary" :loading="editBtnLoading" @click="centerDialogVisibleSave">保 存</el-button>
					</span>
				</div> -->
			</el-dialog>
			<UploadFile :uploadDialogVisible="uploadDialogVisible" :isAccept="isAccept" :isFileCheck="isFileCheck"
				:isFlag="true" :isVideo="isVideo" @cancel="cancel" @sureUpload="sureUpload" />
			<el-tab-pane label="自定义群发" name="second">
				<div class=""
					style="display: flex;justify-content: space-between;width: 100%;height: 60.4vh;overflow-y: auto;">
					<div class="" style="width: 50%;">
						<el-form ref="forms" :model="form" :rules="formRules" label-width="100px">
							<el-form-item label="目标筛选" prop="isScreens">
								<el-switch v-model="form.isScreens" active-text="是" inactive-text="否"
									@change="isScreensChange">
								</el-switch>
							</el-form-item>
							<el-form-item v-if="form.isScreens" label="">
								<div class="" style="display: flex;justify-content: space-between;">
									<div class="" style="display: flex;width: 58%;justify-content: space-between;">
										<el-select style="width: 49%;" v-model="form.test" placeholder="是否测试" clearable>
											<el-option label="是" value="shanghai"></el-option>
											<el-option label="否" value="beijing"></el-option>
										</el-select>
										<el-select style="width: 49%;" v-model="form.signIn" placeholder="是否签到"
											clearable>
											<el-option label="是" value="shanghai"></el-option>
											<el-option label="否" value="beijing"></el-option>
										</el-select>
									</div>
									<div class="" style="display: flex;width: 41%;">
										<el-select style="width: 100%;" v-model="form.grouping" placeholder="类型/分组"
											clearable>
											<el-option v-for="(item,index) in meetingVoteData" :label="item.groupName"
												:value="item.groupId"></el-option>
										</el-select>
									</div>
								</div>
								<div class=""
									style="display: flex;justify-content: space-between;width: 100%;margin-top: 10px;">
									<div class="" style="width: 58%;">
										<el-select style="width: 100%;" v-model="form.voteId" placeholder="表决事项"
											clearable @change="voteIdChange">
											<el-option v-for="(item,index) in voteList" :label="item.name"
												:value="item.id"></el-option>
										</el-select>
									</div>
									<div class="" style="width: 41%;">
										<el-select style="width: 100%;" v-model="form.optionId" placeholder="表决选项"
											clearable no-data-text="请选择表决事项">
											<el-option v-for="(item,index) in voteOptions" :label="item.name"
												:value="item.id"></el-option>
										</el-select>
									</div>
								</div>
							</el-form-item>
							<el-form-item label="任务标题">
								<el-input v-model="form.title" placeholder="任务标题,非必填" clearable></el-input>
							</el-form-item>

							<!-- <el-form-item label="签名与后缀">
										<div class=""
											style="padding: 0px 15px;border: 1px solid #dcdfe6;height: 39px;line-height: 32px;border-radius: 4px;display: flex;align-items: center;">
											<div class="">
												签名：
											</div>
											<div class="noBorder">
												<el-select style="color: #3772DE;width: 100px;" v-model="ruleForm.region"
													placeholder="请选择签名">
													<el-option label="区域一" value="shanghai"></el-option>
													<el-option label="区域二" value="beijing"></el-option>
												</el-select>
											</div>
										</div>
									</el-form-item> -->
							<el-form-item label="编辑内容" prop="content">
								<div class="" style="width: 100%;">
									<el-input v-model="form.content" type="textarea"
										:autosize="{ minRows: 6, maxRows: 6}" clearable>
									</el-input>
									<div class=""
										style="display: flex;align-items: center;justify-content: flex-end;color: #666666;">
										<div class="">
											已输入
										</div>
										<div class="" style="color: #ff8c55;margin-left: 5px;margin-right: 5px;">
											{{form.content.length+5}}个字符，
										</div>
										<div class="">
											消耗
										</div>
										<div class="" style="color: #ff8c55;margin-left: 5px;margin-right: 5px;">
											{{(form.content.length + 5) < 70?Math.ceil((form.content.length+5) / 70):Math.ceil((form.content.length+5) / 67)}}
										</div>
										<div class="">
											条短信
										</div>
										<div class="" style="margin-left: 5px;font-size: 14px;">
											<el-tooltip class="item" effect="dark" content="" placement="top">
												<div class="" slot="content" style="width: 200px;line-height: 20px;">
													短信字数小于70个字符，计费一条。短信字数大于70个字符，则为长短信，按照每67个字符做为一条短信进行计费。标点符号占用一个字符。
												</div>
												<i class="el-icon-question"></i>
											</el-tooltip>
										</div>

									</div>
								</div>
							</el-form-item>
							<el-form-item label="发送手机号" prop="inputPhoneNumberText">
								<div class="" style="width: 100%;">
									<!-- @keyup.enter.native="submitForm" -->
									<el-input @input="submitForm" v-model="form.inputPhoneNumberText" type="textarea"
										:autosize="{ minRows: 5, maxRows: 5}" clearable>
									</el-input>
									<div class=""
										style="display: flex;margin-top: 10px;align-items: center;justify-content: space-between;">
										<div class="" style="display: flex;">
											<el-button icon="el-icon-daoru" style="border-color: #3772DE;color:#3772DE;"
												@click="
													    uploadDialogVisible = true;
													isAccept = false;
													isFileCheck = false;
													isVideo = false;">文件导入</el-button>
											<el-button icon="el-icon-download"
												style="margin-left: 10px;border-color: #3772DE;color:#3772DE;">
												<a href="/xlxs/手机号导入模板.xlsx"
													style="border-color: #3772DE;color:#3772DE;">下载模板</a>
											</el-button>
										</div>
										<!-- <el-button @click="fileImportClick" style="border-color: #3772DE;color:#3772DE;">文件导入</el-button> -->
										<div class="" style="display: flex;align-items: center;color: #666666;">
											<div class="">
												已输入 <span id="" style="color: #D43030;">
													{{form.inputPhoneNumber.length}}
												</span>个
											</div>

											<div class="" style="display: flex;align-items: center;margin-left: 5px;">
												（<el-button @click="centerDialogVisibleClick('1')" type="text" style="">
													查看 </el-button>）
											</div>


											<!-- <div class="" style="margin-left: 10px;">
														详情
													</div> -->
											<div class=""
												style="width: 1px;height: 20px;margin: 0px 10px;background-color: #CCCCCC;">

											</div>
											<div class="">
												已导入<span id="" style="color: #D43030;">
													{{form.toLeadPhoneNumber.length}}
												</span>个
											</div>
											<div class="" style="display: flex;align-items: center;margin-left: 5px;">
												（<el-button @click="centerDialogVisibleClick('2')" type="text" style="">
													查看</el-button>）
											</div>
											<div class=""
												style="width: 1px;height: 20px;margin: 0px 10px;background-color: #CCCCCC;">

											</div>
											<div class="">
												共<span id="" style="color: #D43030;">
													{{form.inputPhoneNumber.length+form.toLeadPhoneNumber.length}}
												</span>个
											</div>
										</div>
									</div>
								</div>

							</el-form-item>
							<el-form-item label="发送统计">
								<div class="">
									<div class="" style="display: flex;align-items: center;">
										<div class=""
											style="display: flex;align-items: center;padding-right: 10px;font-size: 14px;color: #666666;">
											<i class="el-icon-message" style="margin-right: 5px;"></i>
											短信 <span id="" style="color: #D43030;">
												{{(form.content.length + 5) < 70?(form.inputPhoneNumber.length+form.toLeadPhoneNumber.length)*(Math.ceil((form.content.length+5) / 70)):(form.inputPhoneNumber.length+form.toLeadPhoneNumber.length)*(Math.ceil((form.content.length+5) / 67))}}
											</span>条
										</div>
										<div class="balloon-left">
											短信余额{{noteBalance}}条
										</div>
									</div>
									<div class="" style="display: flex;align-items: center;">
										<div class=""
											style="display: flex;align-items: center;padding-right: 10px;font-size: 14px;color: #666666;">
											<i class="el-icon-mobile-phone" style="margin-right: 5px;"></i>
											手机号 <span id="" style="color: #D43030;">
												{{form.inputPhoneNumber.length+form.toLeadPhoneNumber.length}}
											</span>个
										</div>
									</div>
								</div>


							</el-form-item>
							<el-form-item>
								<el-button style="width: 180px;height: 40px;" size="medium" type="primary"
									@click="onSubmit" :loading="onSubmitLoading">提交发送</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="" style="width: 50%;">
						<div class="" style="display: flex;justify-content: center;width: 100%;">
							<div class=""
								style="width: 300px;height: 540px;display: flex;align-items: center;justify-content: center;border-radius: 25px;background-color: #DDDDDD;">
								<div class=""
									style="width: 280px;height: 500px;background-color: #FFFFFF;border-radius: 10px;">
									<div class="chatBox chatBox-left"
										style="font-size: 14px;color: #333333;line-height: 20px;">
										【破产云】{{form.content}}
									</div>
								</div>
							</div>
						</div>
						<div class=""
							style="width: 100%;text-align: center;font-size: 14px;color: #333333;margin-top: 20px;">
							短信演示效果
						</div>


					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="发送记录" name="third">
				<div class="meeting-search">
					<el-form :inline="true" :model="recordForm" class="demo-form-inline">
						<el-form-item label="短信模板">
							<el-select style="width: 320px;" v-model="recordForm.meeting_lianlu_msg_id" placeholder="短信模板" clearable>
								<el-option label="全部" value=""></el-option>
								<el-option v-for="(item, index) in smsListArr" :key="index" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="短信状态">
							<el-select style="width: 320px;" v-model="recordForm.status" placeholder="短信状态" clearable>
								<el-option label="全部" value=""></el-option>
								<el-option label="已发送" value="00"></el-option>
								<el-option label="待审核" value="14"></el-option>
								<el-option label="驳回" value="15"></el-option>
								<el-option label="未发送" value="17"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="任务标题">
							<el-input style="width: 320px;" v-model.trim="recordForm.taskName" clearable
								placeholder="请输入"></el-input>
						</el-form-item>
						<!-- <el-form-item label="发送内容">
							<el-input style="width: 270px;" v-model.trim="recordForm.content" clearable
								placeholder="请输入"></el-input>
						</el-form-item> -->
						<el-form-item label="短信内容">
							<el-input style="width: 320px;" v-model.trim="recordForm.content" clearable
								placeholder="请输入"></el-input>
						</el-form-item>
						<el-form-item label="发布时间">
							<el-date-picker v-model="value" type="datetimerange" range-separator="至"
								start-placeholder="开始时间" end-placeholder="结束时间" style="width: 400px">
							</el-date-picker>
						</el-form-item>
						<el-form-item class="meeting-search-button">
							<!-- style="background: #de4d2a !important"  -->
							<el-button type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
						</el-form-item>
						<el-form-item class="meeting-search-button">
							<!-- style="background: #de4d2a !important"  -->
							<el-button icon="el-icon-daochu" @click="exportTaskList">导出
							</el-button>
						</el-form-item>
						<div class="" style="float: right;">
							<el-form-item>
								<div class="flex align-center">
									<div class=""
										style="font-size: 14px;font-weight: 400;color: #FF5733;margin-right: 16px;">
										短信状态可能有延迟，可等5-10分钟后刷新
									</div>
									<el-button @click="onRefresh">刷新</el-button>
								</div>
							</el-form-item>
						</div>
					</el-form>
				</div>
				<!-- <div class="refresh">
                    阿里云和供应商短信状态回执存在延迟，系统可能更新不及时，可稍等5-10分钟后刷新该页面<el-button
                        style="margin: 0 5px"
                        @click="onRefresh"
                        >刷新</el-button
                    >
                </div> -->
				<el-table ref="multipleTable2" @selection-change="handleSelectionChange" :data="smsList" size="medium"
					v-loading="loading" height="41.8vh" class="sms-table">
					<el-table-column type="selection" width="50"> </el-table-column>
					<el-table-column prop="serialNumber" label="序号" align="center" width="50px"></el-table-column>
					<el-table-column width="150px" label="状态" align="center">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.status=='00'" type="success">已发送</el-tag>
							<el-tag v-if="scope.row.status=='14'" type="info">待审核</el-tag>
							<el-tag v-if="scope.row.status=='15'" type="warning">驳回</el-tag>
							<el-tag v-if="scope.row.status=='17'" type="danger">未发送</el-tag>
						</template>
					</el-table-column>
					<el-table-column width="150px" prop="taskName" label="标题" align="center">
						<template slot-scope="scope">
							{{scope.row.taskName==null?'无':scope.row.taskName}}
						</template>
					</el-table-column>
					<el-table-column min-width="50%" prop="contentDetail" label="短信内容" align="center">
						<template slot-scope="scope">
							<div :title="scope.row.content"
								style="text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;line-clamp: 2;-webkit-box-orient: vertical;">
								{{ scope.row.content }}
							</div>
						</template>
					</el-table-column>
					<el-table-column width="150px" prop="msgCount" label="短信条数" align="center"> </el-table-column>
					<el-table-column width="150px" prop="phoneNum" label="号码数" align="center"> </el-table-column>
					<el-table-column width="150px" prop="createTime" label="提交时间" align="center">
						<template slot-scope="scope">
							{{ scope.row.createTime?timeFormat(scope.row.createTime):'无'  }}
						</template>
					</el-table-column>
					</el-table-column>
					<el-table-column width="150px" prop="sendTime" label="发送时间" align="center">
						<template slot-scope="scope">
							{{ scope.row.sendTime?timeFormat(scope.row.sendTime):'无'  }}
						</template>
					</el-table-column>
					</el-table-column>
					<el-table-column width="150px" label="操作" align="center">
						<template slot-scope="scope">
							<el-button type="text" @click.stop="SMSSendingDetailsDialogVisibleClick(scope.row)"
								style="margin-right: 10px;">详情</el-button>
							<el-popconfirm title="确认重发吗？" confirm-button-type="text"
								@onConfirm="SMSSendingDetailsDialogVisibleRetry(scope.row)">
								<el-button slot="reference" :loading="scope.row.btnLoading" type="text">重发</el-button>
								<!-- <el-button icon="el-icon-shanchu1" v-if="userInfo.type != 'MANAGER'" slot="reference"
										class="operation" size="16px"
										type="text"></el-button> -->
							</el-popconfirm>

						</template>
					</el-table-column>
				</el-table>
				<!-- v-if="activeName == 'second'" -->
				<Pagination v-if="activeName == 'third'" :total="total" @handleSizeChange="turnPage"
					@handleCurrentChange="turnPage" customClass="alone" />

				</Pagination>
			</el-tab-pane>

			<!-- <template v-slot:operation>
				<div style="padding-left: 25px">
					<el-button @click="toggleSelection('multipleTable2')" plain>取消选择</el-button>
					<el-button @click.stop="againSend('batch')" :loading="batchLoading" type="primary">批量重发
					</el-button>
				</div>
			</template> -->
		</el-tabs>
		<el-dialog title="短信发送详情" :close-on-click-modal="false" :visible.sync="SMSSendingDetailsDialogVisible"
			width="60%" :center="false" append-to-body :before-close="eliminate">
			<div class=""
				style="width: 100%;display: flex;align-items: center;justify-content: center;margin-bottom: 20px;">
				<div class=""
					style="display: flex;align-items: center;justify-content: space-between;width: 80%;font-size: 18px;color: #74798C;">
					<div class="" style="display: flex;align-items: center;">
						<div class="" style="width: 20px;height: 15px;background-color: #33B8F5;">

						</div>
						<div class="" style="margin-left: 5px;">
							短信条数：
						</div>
						<div class="" style="font-size: 20px;color: #282F36;font-weight: 700;margin-bottom: -5px;">
							{{taskDetailsStatisticsData.contentCount}}
						</div>
					</div>
					<div class="" style="display: flex;align-items: center;">
						<div class="" style="width: 20px;height: 15px;color: #009944;">
							<i class="el-icon-check"></i>
						</div>
						<div class="" style="margin-left: 5px;">
							成功发送：
						</div>
						<div class="" style="font-size: 20px;color: #282F36;font-weight: 700;margin-bottom: -5px;">
							{{taskDetailsStatisticsData.countSuccess}}
						</div>
					</div>
					<div class="" style="display: flex;align-items: center;">
						<div class="" style="width: 20px;height: 15px;color: #FF5733;">
							<i class="el-icon-close"></i>
						</div>
						<div class="" style="margin-left: 5px;">
							失败：
						</div>
						<div class="" style="font-size: 20px;color: #282F36;font-weight: 700;margin-bottom: -5px;">
							{{taskDetailsStatisticsData.countFailed}}
						</div>
					</div>
					<div class="" style="display: flex;align-items: center;">
						<div class="" style="width: 18px;height: 18px;background-color: #ff8d1a;border-radius: 50%;">

						</div>
						<div class="" style="margin-left: 5px;">
							正在获取状态：
						</div>
						<div class="" style="font-size: 20px;color: #282F36;font-weight: 700;margin-bottom: -5px;">
							{{taskDetailsStatisticsData.countSending}}
						</div>
					</div>
				</div>
			</div>
			<div class="">
				<el-form :inline="true" :model="taskDetailsRecordForm" class="demo-form-inline">
					<el-form-item label="手机号码">
						<el-input style="width: 270px;" v-model.trim="taskDetailsRecordForm.phone" clearable
							placeholder="请输入"></el-input>
					</el-form-item>
					<!-- <el-form-item label="运营商">
						<el-select style="width: 270px;" v-model="taskDetailsRecordForm.content" placeholder="短信模板" clearable>
							<el-option label="全部" value=""></el-option>
							<el-option v-for="(item, index) in smsListArr" :key="index" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="状态">
						<el-select style="width: 270px;" v-model="taskDetailsRecordForm.status" placeholder="短信状态"
							clearable>
							<el-option label="全部" value=""></el-option>
							<el-option label="正在获取状态" value="0"></el-option>
							<el-option label="接收成功" value="1"></el-option>
							<el-option label="接收失败" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="meeting-search-button">
						<!-- style="background: #de4d2a !important"  -->
						<el-button type="primary" icon="el-icon-search" @click="getTaskDetailsListSearch">查询
						</el-button>
					</el-form-item>
					<el-form-item class="meeting-search-button">
						<!-- style="background: #de4d2a !important"  -->
						<el-button icon="el-icon-daochu" @click="exportTaskDetailsList">导出
						</el-button>
					</el-form-item>

				</el-form>
			</div>
			<el-table ref="multipleTable1" @selection-change="handleSelectionChange" :data="taskDetailsList"
				size="medium" v-loading="taskDetailsListLoading" height="450px">
				<el-table-column prop="serialNumber" label="序号" align="center" width="50px"></el-table-column>
				<el-table-column prop="content" label="内容" align="center" min-width="230px">
					<template slot-scope="scope">
						<div class="" :title="scope.row.content"
							style="overflow:hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow:ellipsis;">
							{{scope.row.content}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="phone" label="手机号码" align="center"> </el-table-column>
				<el-table-column label="状态" align="center" width="120px">
					<template slot-scope="scope">
						<div class="" style="display: flex;align-items: center;">
							<el-tag v-if="scope.row.status=='1'" type="success">接收成功</el-tag>
							<el-tag v-if="scope.row.status=='2'" type="warning">接收失败</el-tag>
							<el-tag v-if="scope.row.status=='0'" type="danger">正在获取状态</el-tag>
							<div v-if="scope.row.status=='2'" class="" style="margin-left: 10px;">
								<el-tooltip class="item" effect="dark" :content="scope.row.message" placement="bottom">
									<i class="el-icon-question"></i>
								</el-tooltip>
							</div>
						</div>

					</template>
				</el-table-column>
				<el-table-column label="发送时间" align="center">
					<template slot-scope="scope">
						{{ scope.row.createTime?timeFormat(scope.row.createTime):'无'  }}
					</template>
				</el-table-column>
				<el-table-column label="接收时间" align="center">
					<template slot-scope="scope">
						{{ scope.row.respTime?timeFormat(scope.row.respTime):'无'  }}
					</template>
				</el-table-column>
			</el-table>
			<Pagination :total="taskDetailsListTotal" @handleSizeChange="taskDetailsTurnPage"
				@handleCurrentChange="taskDetailsTurnPage" customClass="alone" />
			</Pagination>
		</el-dialog>
		<el-dialog title="编辑短信参数" :close-on-click-modal="false" :visible.sync="centerDialogVisible" width="500px"
			:center="false" append-to-body>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
				<el-form-item label="会议名称" prop="meetingName">
					<el-input style="width: 220px" v-model="ruleForm.meetingName" placeholder="请输入会议名称, 且最多不能超过20字">
					</el-input>
				</el-form-item>
				<!-- <el-form-item label="联系管理人" prop="administrator">
					<el-input style="width: 220px" v-model="ruleForm.administrator" placeholder="请输入管理人, 且最多不能超过20字">
					</el-input>
				</el-form-item>
				<el-form-item label="管理人联系电话" prop="contactNumber">
					<el-input style="width: 220px" v-model="ruleForm.contactNumber" placeholder="请输入管理人联系电话"></el-input>
				</el-form-item> -->
				<el-form-item label="召开时间" prop="startTime">
					<el-date-picker format="yyyy-MM-dd HH:mm" v-model="ruleForm.startTime" type="datetime"
						placeholder="选择召开时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="测试截止时间" prop="endTime" v-if="type && type.includes('SMS_MEETING_TESTING')">
					<el-date-picker format="yyyy-MM-dd HH:mm" v-model="ruleForm.endTime" type="datetime"
						placeholder="选择结束时间">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<div class="flex align-center justify-center">
				<span slot="footer" class="dialog-footer">
					<el-button @click="centerDialogVisible = false">取 消</el-button>
					<el-button type="primary" :loading="editBtnLoading" @click="sureEditSms('ruleForm')">保 存</el-button>
				</span>
			</div>
		</el-dialog>
		<el-dialog title="提示" :close-on-click-modal="false" :visible.sync="centerDialogVisibless" width="500px"
			:center="false" append-to-body :before-close="centerDialogVisiblessCloseDialog">
			<div class="">
				<div v-if="error.length>0" class="" style="display: flex;margin-bottom: 20px;text-align: left;">
					<div class="" style="width: 125px;">
						错误手机号码：
					</div>
					<div class="" style="text-align: left;width: 100%;">
						{{error.join(',')}}
					</div>
				</div>
				<div v-if="repetition.length>0" class="" style="display: flex;">
					<div class="" style="width: 125px;">
						重复手机号码：
					</div>
					<div class="" style="text-align: left;width: 100%;">
						{{repetition.join(',')}}
					</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="个人发送记录" :visible.sync="personDialogVisible" v-if="personDialogVisible" width="1060px"
			:center="false" append-to-body :close-on-click-modal="false" :before-close="closeDialog">
			<!-- <el-card class="box-card"> -->
			<div class="meeting-search" style="padding: 20px 20px 0px 20px;">
				<el-form :inline="true" :model="recordForm" class="demo-form-inline">
					<el-form-item label="短信模板">
						<el-select v-model="recordForm.tmplCode" placeholder="短信模板" clearable>
							<el-option label="全部" value=""></el-option>
							<el-option v-for="(item, index) in smsListArr" :key="index" :label="item.name"
								:value="item.tmplCode"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="短信状态">
						<el-select v-model="recordForm.sendResult" placeholder="短信状态" clearable>
							<el-option label="全部" value=""></el-option>
							<el-option label="发送中" value="WAIT"></el-option>
							<el-option label="发送成功" value="SUCCESS"></el-option>
							<el-option label="发送失败" value="FAIL"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="手机号">
						<el-select v-model="recordForm.phone" clearable>
							<el-option label="全部" value=""></el-option>
							<el-option v-for="(item, index) in phones" :key="index" :label="item" :value="item">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="时间">
						<el-date-picker v-model="value" type="datetimerange" range-separator="至"
							start-placeholder="开始时间" end-placeholder="结束时间" style="width: 437px">
						</el-date-picker>
					</el-form-item>
					<el-form-item class="meeting-search-button">
						<el-button icon="el-icon-search" type="primary" @click="onSearch">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="refresh" style="margin-bottom: 20px;margin-left: 20px;">
				阿里云和供应商短信状态回执存在延迟，系统可能更新不及时，可稍等5-10分钟后刷新该页面<el-button style="margin: 0 5px"
					icon="el-icon-zhongzhishaixuan" @click="onRefresh">刷新
				</el-button>
			</div>
			<el-table ref="multipleTable1" @selection-change="handleSelectionChange" :data="personSmsList" size="medium"
				v-loading="loading" height="450px">
				<el-table-column type="selection" width="50"> </el-table-column>
				<el-table-column prop="serialNumber" label="序号" align="center" width="50px"></el-table-column>
				<el-table-column prop="name" label="姓名" align="center"> </el-table-column>
				<el-table-column prop="toCode" label="手机号" align="center"> </el-table-column>
				<el-table-column prop="tmplName" label="短信名" align="center"> </el-table-column>
				<el-table-column label="状态" align="center">
					<template slot-scope="scope">
						{{ scope.row.sendResult === 'WAIT' ? '发送中' : scope.row.sendResult === 'SUCCESS' ? '发送成功' : '发送失败' }}
					</template>
				</el-table-column>
				<el-table-column label="时间" align="center">
					<template slot-scope="scope">
						{{ timeFormat(scope.row.sendTime) }}
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="text" :loading="scope.row.btnLoading"
							@click.stop="againSend('single', scope.row)">重新发送</el-button>
					</template>
				</el-table-column>
			</el-table>
			<Pagination :total="personalTotal" @handleSizeChange="turnPage" @handleCurrentChange="turnPage">
				<template v-slot:operation>
					<div style="padding-left: 25px">
						<el-button @click="toggleSelection('multipleTable1')" plain
							style="border: 1rpx solid #2766FF;color: #2766FF;border-color:#2766FF;">取消选择</el-button>
						<!--   style="background: #de4d2a !important" -->
						<el-button @click.stop="againSend('batch')" :loading="batchLoading"
							style="border: 1rpx solid #2766FF;color: #2766FF;border-color:#2766FF;">批量重发
						</el-button>
					</div>
				</template>
			</Pagination>
			<!-- </el-card> -->
			<!-- <span slot="footer" class="dialog-footer">
				<el-button @click="closeDialog" type="primary">关 闭</el-button>
			</span> -->
		</el-dialog>
	</div>
</template>

<script>
	import moment from 'moment';
	import {
		getSmsList,
		groupSMS,
		getSmsRecordList,
		editSMS,
		againSend,
		getMeetingManager,
		getSmsListCount,
		getSmsRecordCount,
		getUserPhones,
		getPhonesExcel,
		createNormalTask,
		getMeetingLianluMsg,
		setLianluMsgParamJson,
		createTmplMsgTask,
		getTaskListCount,
		getTaskList,
		getTaskDetailsList,
		getTaskDetailsListCount,
		getTaskDetailsStatistics,
		lianluMsgResend,
		exportTaskList
	} from '@/serve/sms';
	import {
		getVoteList,
	} from '@/serve/userGrouping';
	import {
		getVoteDetail
	} from '@/serve/userGrouping.js';
	import {
		getUserMsgCount,
		getBalance
	} from '@/serve/user';
	import Pagination from '@/components/Pagination';
	import UploadFile from '@/components/uploadFile';
	import bus from '@/utils/bus';
	import {
		mapState
	} from 'vuex';
	export default {
		components: {
			Pagination,
			UploadFile
		},
		props: {
			isActiveName: String,
			meetingId: String,
			smsTemplateList: Array,
			meetingData: Array,
			meetingVoteData: Array,
		},
		watch: {
			isActiveName(newVal, oldVal) {
				if (newVal === 'first') {
					this.getSmsList();
					this.handleClicks();
				}
			},
		},
		data() {
			var validatePass = (rule, value, callback) => {
				if (this.form.inputPhoneNumber.length == 0 && this.form.toLeadPhoneNumber.length == 0) {
					callback(new Error('请输入发送手机号码或文件导入手机号码'));
				} else {
					callback();
				}
			};
			var validatePasss = (rule, value, callback) => {
				if (this.form.meetingLianluMsg.name == '') {
					callback(new Error('请选项模板'));
				} else {
					callback();
				}
			};
			return {
				value2: true,
				batchLoading: false,
				personalTotal: 0,
				total: 0,
				ids: [],
				value: [],
				loading: false,
				btnLoading: false,
				editBtnLoading: false,
				activeName: 'first',
				activeNames: 'first',
				smsList: [],
				smsListArr: [],
				multipleSelection: [],
				personSmsList: [],
				message: '',
				centerDialogVisible: false,
				personDialogVisible: false,
				phones: [],
				isPersonFlag: false,
				type: '',
				smsRow: {},
				ruleForm: {
					administrator: '',
					contactNumber: '',
					meetingName: '',
					startTime: '',
					endTime: '',
					meeting: ''
				},
				contentText: '',
				managers: [],

				rules: {
					administrator: [{
						required: true,
						message: '请输入管理人',
						trigger: 'blur'
					}],
					contactNumber: [{
						required: true,
						message: '请输入管理人联系电话',
						trigger: 'blur'
					}],
					meetingName: [{
						required: true,
						message: '请输入会议名称',
						trigger: 'blur'
					}],
					startTime: [{
						required: true,
						message: '请选择召开时间',
						trigger: 'blur'
					}],
					endTime: [{
						required: true,
						message: '请输入测试截止时间',
						trigger: 'blur'
					}],
					meeting: [{
						required: true,
						message: '请输入参会地址',
						trigger: 'blur'
					}]
				},
				recordForm: {
					content: '',
					keyword: '',
					endTime: '',
					startTime: '',
					roleType: '',
					page: 0,
					rows: 20,
					lastSent: '',
					sendResult: '',
					tmplCode: '',
					username: '',
					userId: '',
					phone: '',
					taskName: '',
				},
				form: {
					isScreens: false,
					title: '',
					test: '',
					signIn: '',
					grouping: '',
					content: '',
					inputPhoneNumber: [],
					toLeadPhoneNumber: [],
					inputPhoneNumberText: '',
					meetingLianluMsg: {
						name: '',
						id: '',
					},
					voteId: '',
					optionId: '',
				},
				formRules: {
					content: [{
						required: true,
						message: '请输入短信内容',
						trigger: 'blur'
					}]
					// ,
					// inputPhoneNumberText: [{
					// 	validator: validatePass,
					// 	required: true,
					// 	trigger: 'blur'
					// }],
				},
				formRuless: {
					meetingLianluMsg: [{
						required: true,
						validator: validatePasss,
						trigger: 'blur'
					}]
					// ,
					// inputPhoneNumberText: [{
					// 	validator: validatePass,
					// 	required: true,
					// 	trigger: 'blur'
					// }],
				},
				uploadDialogVisible: false,
				isAccept: false,
				isFileCheck: false,
				isVideo: false,
				phoneList: [],
				phoneLists: [],
				phoneListNumber: 0,
				phoneListPage: 1,
				rows: 20,
				centerDialogVisibleType: '',
				keyword: '',
				templateDialogVisible: false,
				meetingLianluMsgList: [],
				centerDialogVisibles: false,
				SMSSendingDetailsDialogVisible: false,
				taskDetailsListTotal: 0,
				taskDetailsList: [],
				taskDetailsRecordForm: {
					page: 0,
					rows: 20,
					content: '',
					phone: '',
					status: '',
				},
				taskDetailsStatisticsData: {
					contentCount: 0,
					countFailed: 0,
					countSending: 0,
					countSuccess: 0,
				},
				taskDetails: '',
				noteBalance: 0,
				centerDialogVisibless: false,
				error: [],
				repetition: [],
				voteList: [],
				voteOptions: [],
				onSubmitLoading: false,
				onSubmitsLoading: false,
				taskDetailsListLoading:false,
			};
		},
		computed: {
			...mapState({
				userInfo: state => state.user.userInfo,
			})
		},
		async created() {
			this.getVoteList();
			this.templateDialogVisibleClick();
		},
		methods: {
			voteIdClear() {
				this.form.voteId = '';
				this.form.optionId = '';
				this.voteOptions = [];
			},
			voteIdChange(e) {
				console.log("e", e)
				if (e != '') {
					this.form.optionId = '';
					this.voteOptions = [];
					this.getVoteDetail(e);
				}
			},
			async getVoteList() {
				getVoteList({
						meeting_id: this.meetingId
					})
					.then((res) => {
						console.log('res:', res);
						this.voteList = res;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
						this.loading = false;
					});
			},
			// 获取表决详情
			getVoteDetail(voteId) {
				getVoteDetail(voteId)
					.then(res => {
						this.groups = res.groups;
						console.log('res.options:', res)
						console.log('res.options', JSON.stringify(res))
						this.voteOptions = res.options;
						let optionIdArray = [];
						res.options.forEach(item => optionIdArray.push(item.id));
						let optionId = optionIdArray.join(",");
						this.voteOptions.push({
							id: optionId,
							voteId: res.options[0].voteId,
							name: '未投'
						});
					})
					.catch(err => {
						this.$message.error(err.data.message);
					});
			},
			exportTaskList() {
				let token = sessionStorage.getItem('ms_token');
				let url =
					`/api/gathering/meeting/${this.meetingId}/lianlu_msg/get_task_list/export?` +
					'content=' + this.recordForm.content + '&keyword=' + this.recordForm.keyword + '&endTime=' + this
					.recordForm.endTime + '&startTime=' + this.recordForm.startTime + '&roleType=' + this.recordForm
					.roleType +
					'&lastSent=true&sendResult=' + this.recordForm.sendResult + '&tmplCode=' + this.recordForm.tmplCode +
					'&access_token=' +
					token
				this.export(url);
			},
			exportTaskDetailsList() {
				let token = sessionStorage.getItem('ms_token');
				let url =
					`/api/gathering/meeting/${this.meetingId}/lianlu_msg/get_task_details_list/${this.taskDetails.taskId}/export?` +
					'content=' + this.taskDetailsRecordForm.content + '&phone=' + this.taskDetailsRecordForm.phone +
					'&status=' + this.taskDetailsRecordForm.status +
					'&access_token=' +
					token
				this.export(url);
			},
			export (url) {
				console.log("url", url)
				const a = document.createElement('a');
				a.setAttribute('href', url);
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			},
			isScreensChange(e) {
				console.log('e', e);
				this.form.isScreens = e;
			},
			SMSSendingDetailsDialogVisibleRetry(row) {
				console.log("jin")
				row.btnLoading = true;
				lianluMsgResend(this.meetingId, row.id)
					.then((res) => {
						if (res.id != '') {
							this.$message.success('发送成功');
						} else {
							this.$message.error("发送失败");
						}
						this.getSmsList();
						row.btnLoading = false;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
						row.btnLoading = false;
					});
			},
			// 翻页
			taskDetailsTurnPage(attr, val) {
				this.taskDetailsRecordForm[attr] = val;
				console.log("taskDetailsRecordForm", this.taskDetailsRecordForm)
				this.getTaskDetailsList();
			},
			eliminate() {
				this.taskDetails = '';
				this.SMSSendingDetailsDialogVisible = false;
			},
			async SMSSendingDetailsDialogVisibleClick(row) {
				this.SMSSendingDetailsDialogVisible = true;
				this.taskDetailsList = [];
				this.taskDetailsListTotal = 0;
				this.taskDetailsStatisticsData = {
					contentCount: 0,
					countFailed: 0,
					countSending: 0,
					countSuccess: 0,
				}
				if (this.taskDetails == '') {
					this.taskDetails = row;
				}
				this.taskDetailsStatisticsData = await getTaskDetailsStatistics(this.meetingId, {
					task_id: this.taskDetails.taskId
				});
				await this.getTaskDetailsList();
			},
			async getTaskDetailsListSearch(){
				this.taskDetailsRecordForm.page = 0;
				this.taskDetailsList = [];
				this.taskDetailsListTotal = 0;
				this.taskDetailsStatisticsData = await getTaskDetailsStatistics(this.meetingId, {
					task_id: this.taskDetails.taskId,
				});
				this.getTaskDetailsList();
			},
			async getTaskDetailsList(){
				this.taskDetailsListLoading = true;
				this.taskDetailsListTotal = await getTaskDetailsListCount(this.meetingId, this.taskDetails.taskId, this
					.taskDetailsRecordForm);
				console.log("taskDetailsListTotal:", this.taskDetailsListTotal)
				if (this.taskDetailsListTotal > 0) {
					let arr = await getTaskDetailsList(this.meetingId, this.taskDetails.taskId, this
						.taskDetailsRecordForm);
					console.log("arr", arr)
					for (let i = 0; i < arr.length; i++) {
						arr[i].serialNumber = i + 1;
					}
					this.taskDetailsList = arr;
				}
				this.taskDetailsListLoading = false;
				console.log("taskDetails", this.taskDetails)
				
			},
			onSubmits() {
				this.$refs['formss'].validate(valid => {
					if (valid) {
						this.onSubmitsLoading = true;
						let params = {
							meetingLianluMsgId: this.form.meetingLianluMsg.id,
						}
						if (this.form.grouping != '') {
							params.groupId = this.form.grouping
						}
						console.log("signIn", this.form.signIn)
						if (this.form.signIn != '') {
							params.sign = this.form.signIn == 'shanghai' ? true : false
						}
						console.log("test", this.form.test)
						if (this.form.test != '') {
							params.test = this.form.test == 'shanghai' ? true : false
						}
						if (this.form.voteId != '') {
							params.voteId = this.form.voteId
						}
						if (this.form.optionId != '') {
							params.optionId = this.form.optionId
						}
						console.log("params", params)
						// return
						createTmplMsgTask(this.meetingId, params)
							.then((res) => {
								if (res.id != '') {
									this.$message.success('发送成功');
								} else {
									this.$message.error("发送失败");
								}
								this.handleClicks();
								this.onSubmitsLoading = false;
							})
							.catch((err) => {
								this.$message.error(err.data.message);
								this.onSubmitsLoading = false;
							});
					}
				})

			},
			employClick(row) {
				console.log("row", row);
				if (row.paramJson == null) {
					this.$message.error("请先配置此模板");
					return
				}

				if (row.id == this.form.meetingLianluMsg.id) {
					this.form.meetingLianluMsg = {
						id: '',
						name: ''
					};
					this.form.content = '';
				} else {
					this.form.content = row.content;
					this.form.meetingLianluMsg = {
						id: row.id,
						name: row.name
					};
				}

				this.templateDialogVisible = false;
			},
			templateDialogVisibleClick() {
				// this.$refs["formss"].clearValidate();
				getMeetingLianluMsg(this.meetingId)
					.then((res) => {
						console.log("res", res);
						this.meetingLianluMsgList = [];
						for (let i = 0; i < res.length; i++) {
							res[i].serialNumber = i + 1;
							this.meetingLianluMsgList.push(res[i])
						}
						console.log("meetingLianluMsgList", this.meetingLianluMsgList)
						// this.templateDialogVisible = true;
					}).catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			centerDialogVisibleOnSearch() {
				this.phoneListPage = 1;
				this.phoneListNumber = 0;
				if (this.keyword != '') {
					let list = [];
					for (let i in this.phoneLists) {
						if (this.phoneLists[i].name.indexOf(this.keyword) != -1) {
							list.push(this.phoneLists[i])
						}
					}
					this.phoneListNumber = list.length;
					if (list.length > this.rows) {
						console.log("list", list)
						let lists = this.spArr(list, this.rows);
						console.log("lists", lists)
						this.phoneList = lists[this.phoneListPage - 1];
					} else {
						console.log("list", list)
						this.phoneList = list;
					}
				} else {
					this.paging();
				}
			},
			centerDialogVisibleSave() {
				let list = [];
				for (let i in this.phoneLists) {
					list.push({
						name: this.phoneLists[i].name
					})
				}
				if (this.centerDialogVisibleType == '1') {
					this.form.inputPhoneNumber = list;
				} else if (this.centerDialogVisibleType == '2') {
					this.form.toLeadPhoneNumber = list;
				}
				console.log("list", list)
				this.centerDialogVisibleType = '';
				this.phoneList = [];
				this.centerDialogVisibles = false;
			},
			deletePhone(index) {
				console.log("index", index)
				let list = [];
				list = JSON.parse(JSON.stringify(this.phoneList));
				for (let i in this.phoneLists) {
					if (this.phoneLists[i].name == list[index].name) {
						this.phoneLists.splice(i, 1);
					}
				}
				list.splice(index, 1);
				console.log("list", list)
				this.phoneList = JSON.parse(JSON.stringify(list));
				console.log("phoneList", this.phoneLists)
				if (this.phoneList.length == 0 && this.phoneListPage > 1) {
					this.phoneListPage = this.phoneListPage - 1;
					this.paging();
				} else {
					this.paging();
				}
				if (this.centerDialogVisibleType == '1') {
					this.form.inputPhoneNumber = JSON.parse(JSON.stringify(this.phoneLists));
				} else if (this.centerDialogVisibleType == '2') {
					this.form.toLeadPhoneNumber = JSON.parse(JSON.stringify(this.phoneLists));
				}
			},
			spArr(arr, num) { //arr是你要分割的数组，num是以几个为一组
				let newArr = [] //首先创建一个新的空数组。用来存放分割好的数组
				for (let i = 0; i < arr.length;) { //注意：这里与for循环不太一样的是，没有i++
					newArr.push(arr.slice(i, i += num));
				}
				return newArr
			},
			paging() {
				let list = [];
				if (this.centerDialogVisibleType == '1') {
					list = JSON.parse(JSON.stringify(this.phoneLists));
					list = this.spArr(list, this.rows);
					this.phoneList = list[this.phoneListPage - 1];
					this.phoneListNumber = this.phoneLists.length;
				} else if (this.centerDialogVisibleType == '2') {
					list = JSON.parse(JSON.stringify(this.phoneLists));
					list = this.spArr(list, this.rows);
					this.phoneList = list[this.phoneListPage - 1];
					this.phoneListNumber = this.phoneLists.length;
				}
			},
			phoneListTurnPage(attr, val) {
				console.log("attr", attr);
				console.log("val", val);
				if (attr == 'rows') {
					this.rows = val;
				} else {
					this.phoneListPage = val + 1
				}
				if (this.keyword == '') {
					this.paging();
				} else {

				}

			},
			centerDialogVisibleClick(type) {
				this.centerDialogVisibleType = type;
				if (this.centerDialogVisibleType == '1') {
					this.phoneLists = JSON.parse(JSON.stringify(this.form.inputPhoneNumber));
					this.phoneListNumber = this.phoneLists.length;
				} else if (this.centerDialogVisibleType == '2') {
					this.phoneLists = JSON.parse(JSON.stringify(this.form.toLeadPhoneNumber));
					this.phoneListNumber = this.phoneLists.length;
				}
				console.log("phoneList", this.phoneLists)
				this.paging();
				this.centerDialogVisibles = true;
			},
			cancel() {
				this.voteForm = {
					calculateRule: 0,
					allowPartVote: false,
					showProportion: false,
					allowWaive: false,
					denominator: 2,
					numerator: 1,
					options: [],
					voteType: 'SINGLE_CHOICE',
					groups: [],
					name: '',
					radio: '',
					content: '',
					subjectId: '' // 会议id
				};
				this.voteDialogVisible = false;
				this.uploadDialogVisible = false;
				this.voteResultDialogVisible = false;
			},
			// sureUpload(id, name, format) {
			// 	bus.$emit('clear');
			// 	this.uploadDialogVisible = false;
			// 	if (this.isAccept || this.isVideo) {
			// 		let ord = 0;
			// 		if (this.meetingVoteData.length > 0) {
			// 			this.meetingVoteData.forEach((item) => {
			// 				ord = ord < item.ord ? item.ord : ord;
			// 			});
			// 		}
			// 		ord++;
			// 		uploadFiles(this.meetingId, {
			// 				docId: id,
			// 				ord: ord,
			// 				type: format,
			// 				name
			// 			})
			// 			.then(() => {
			// 				this.$message.success('文件上传成功');
			// 				if (this.isVideo) {
			// 					this.fileActiveName = 'second';
			// 				}
			// 				this.getMeetingFiles();
			// 			})
			// 			.catch((err) => {
			// 				this.$message.error(err.data.message);
			// 			});
			// 	} else {
			// 		this.isShow = true;
			// 		importGroupUser(this.meetingId, {
			// 				fileId: id
			// 			})
			// 			.then((res) => {
			// 				this.progressId = res.id;
			// 				this.fileProgressUpload(this.progressId);
			// 			})
			// 			.catch((err) => {
			// 				this.$message.error(err.data.message);
			// 			});
			// 	}
			// },
			// 文件进度接口
			fileProgressUpload(id) {
				importProgress(this.meetingId, id)
					.then((res) => {
						this.fileCount = res.count;
						this.isFinish = res.finished;
						if (res.total) {
							this.percentage = parseInt((100 * this.fileCount) / res.total);
						}
						this.timer = setTimeout(() => {
							this.fileProgressUpload(this.progressId);
						}, 500);
					})
					.catch((err) => {
						console.log('err', err);
						this.isShow = false;
						if (err.status === 400) {
							this.importDialogVisible = true;
							this.person = [...new Set(err.data.data)].join(',');
						}
					});
			},
			getPhonesExcels(id) {
				let that = this;
				getPhonesExcel(this.meetingId, id)
					.then((res) => {
						console.log("res", res);
						// that.form.toLeadPhoneNumber = [];
						for (let i in res.phones) {
							that.form.toLeadPhoneNumber.push({
								name: res.phones[i]
							})
						}
						if (res.errPhones.length > 0) {
							this.centerDialogVisibless = true;
							this.error = res.errPhones;
						}
						that.form.toLeadPhoneNumber = that.noRepeat(that.form.toLeadPhoneNumber);
						console.log("this.form.toLeadPhoneNumber", that.form.toLeadPhoneNumber)
					}).catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			noRepeat(arr) {
				const res = new Map()
				return arr.filter((a) => !res.has(a.name) && res.set(a.name, 1))
			},
			// 确认上传
			sureUpload(id, name, format) {
				bus.$emit('clear');
				this.uploadDialogVisible = false;
				console.log("id", id)
				console.log("name", name)
				console.log("format", format)
				this.getPhonesExcels(id);
			},
			centerDialogVisiblessCloseDialog() {
				this.repetition = [];
				this.error = [];
				this.centerDialogVisibless = false;
			},
			submitForm(e) {
				console.log("e", e);
				let list = e.split('\n');
				console.log("list", list)
				let regPhone = /^1[3456789]{1}\d{9}$/; //手机正则
				let succeed = [];
				let error = [];
				if (e.length >= 11) {
					for (let i = 0; i < list.length; i++) {
						if (!regPhone.test(list[i])) {
							error.push(list[i])
						} else {
							succeed.push({
								name: list[i]
							})
						}
					}
					let repetition = [];
					repetition = this.repeatElement(succeed, this.form.inputPhoneNumber);
					this.repetition = repetition;
					this.error = error;
					if (this.repetition.length || this.error.length) {
						this.centerDialogVisibless = true;
					}
					this.form.inputPhoneNumber = [...this.form.inputPhoneNumber, ...succeed];
					this.form.inputPhoneNumber = this.noRepeat(this.form.inputPhoneNumber);
					this.form.inputPhoneNumberText = '';
				}
				console.log("this.form", this.form)
			},
			repeatElement(a, b) {
				let arr1 = []
				for (let i = 0; i < a.length; i++) {
					for (let j = 0; j < b.length; j++) {
						if (a[i].name == b[j].name && arr1.indexOf(a[i].name) == -1) {
							arr1.push(a[i].name)
						}
					}
				}
				return arr1
			},
			chuli(phones, data) {
				for (let i = 0; i < data.length; i++) {
					phones.push(data[i])
				}
				return phones
			},
			async onSubmit() {
				this.$refs['forms'].validate(valid => {
					if (valid) {
						this.onSubmitLoading = true;
						let phones = [];
						phones = this.chuli(phones, this.form.toLeadPhoneNumber);
						phones = this.chuli(phones, this.form.inputPhoneNumber);
						//  for (let i = 0; i < this.form.toLeadPhoneNumber.length; i++) {
						// 	phones.push(this.form.toLeadPhoneNumber[i].name)
						// }
						// await for (let i = 0; i < this.form.inputPhoneNumber.length; i++) {
						// 	phones.push(this.form.inputPhoneNumber[i].name)
						// }
						phones = this.noRepeat(phones);
						let list = [];
						for (let i = 0; i < phones.length; i++) {
							list.push(phones[i].name)
						}
						console.log("this.form.isScreens", this.form.isScreens)
						let params = {
							content: this.form.content,
							phones: list,
							taskName: this.form.title,
							groupId: this.form.grouping,
							isScreen: this.form.isScreens ? true : false,
						}
						if (this.form.signIn == 'shanghai') {
							params.sign = true
						}
						if (this.form.test == 'shanghai') {
							params.test = true
						}
						if (this.form.voteId != '') {
							params.voteId = this.form.voteId
						}
						if (this.form.optionId != '') {
							params.optionId = this.form.optionId
						}
						console.log("params", params)
						// return
						createNormalTask(this.meetingId, params)
							.then((res) => {
								if (res.id != '') {
									this.$message.success('发送成功');
								} else {
									this.$message.error("发送失败");
								}
								this.onSubmitLoading = false;
							})
							.catch((err) => {
								this.$message.error(err.data.message);
								this.onSubmitLoading = false;
							});
					}

				})

			},
			// 获取表决分组列表
			getGroupList() {
				this.loading = true;
				getGroupList(this.meetingId)
					.then((res) => {
						for (let i = 0; i < res.length; i++) {
							res[i].serialNumber = i + 1;
						}
						console.log("分组：",res);
						this.meetingVoteData = this.handleTableList(res);
						this.loading = false;
						this.percentage = 0;
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error(err.data.message);
					});
			},
			async handleClick(tab) {
				// this.getSmsList();
				// this.getSmsList();
				if (tab.name == "first" || tab.name == "second") {
					this.form = {
						title: '',
						test: '',
						signIn: '',
						grouping: '',
						content: '',
						inputPhoneNumber: [],
						toLeadPhoneNumber: [],
						inputPhoneNumberText: '',
						meetingLianluMsg: {
							name: '',
							id: '',
						},
						voteId: '',
						optionId: '',
					}
					console.log("userInfo", this.userInfo)
					this.noteBalance = this.userInfo.type == "ADMIN" ? await getBalance() : await getUserMsgCount(this
						.userInfo.id);
					console.log("tab", tab)
				} else if (tab.name == "third") {
					this.getSmsList();
				}
			},
			async handleClicks(tab) {
				// 
				this.form = {
					title: '',
					test: '',
					signIn: '',
					grouping: '',
					content: '',
					inputPhoneNumber: [],
					toLeadPhoneNumber: [],
					inputPhoneNumberText: '',
					meetingLianluMsg: {
						name: '',
						id: '',
					},
					voteId: '',
					optionId: '',
				}
				console.log("userInfo", this.userInfo)
				this.noteBalance = this.userInfo.type == "ADMIN" ? await getBalance() : await getUserMsgCount(this
					.userInfo.id);
				console.log("tab", tab)
				// if(tab.name=="second"){
				// 	this.getSmsList();
				// }
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
				this.ids = this.multipleSelection.map((item) => {
					return {
						id: item.id
					};
				});
			},
			timeFormat(timescape) {
				return moment(timescape).format('YYYY-MM-DD HH:mm:ss');
			},
			// 翻页
			turnPage(attr, val) {
				this.recordForm[attr] = val;
				this.isPersonFlag ? this.getPersonSmsList() : this.getSmsList();
			},
			toggleSelection(val) {
				this.$refs[val].clearSelection();
			},
			// 重新发送
			againSend(type, row) {
				if (type === 'single') {
					row.btnLoading = true;
					this.ids = [{
						id: row.id
					}];
				} else {
					if (!this.ids.length) {
						return this.$message.warning('请先选择发送记录');
					}
					this.batchLoading = true;
				}
				againSend(this.meetingId, this.ids)
					.then(() => {
						this.ids = [];
						type === 'single' ? (row.btnLoading = false) : (this.batchLoading = false);
						this.$message.success(type === 'single' ? '发送成功' : '批量发送成功');
					})
					.catch((err) => {
						this.ids = [];
						type === 'single' ? (row.btnLoading = false) : (this.batchLoading = false);

						this.$message.error(err.data.message);
					});
			},
			// 搜索
			onSearch() {
				this.recordForm.page = 0;
				if (this.value && this.value.length) {
					this.recordForm.startTime = this.value[0].getTime();
					this.recordForm.endTime = this.value[1].getTime();
				}
				console.log("isPersonFlag", this.isPersonFlag)
				this.loading = true;
				this.isPersonFlag ? this.getPersonSmsList() : this.getSmsList();
			},
			onRefresh() {
				this.isPersonFlag ? this.getPersonSmsList() : this.getSmsList();
			},
			// 获取短信列表
			async getSmsList() {
				let arr;
				this.loading = true;
				console.log("activeName", this.activeName);
				if (this.activeName === 'first') {
					arr = await getSmsList(this.meetingId, {
						page: 0,
						rows: 100
					});
					arr.forEach((item) => {
						item.contentShow = item.content;
						this.getExecStrs(item.content).forEach((citem) => {
							while (item.content.includes(citem)) {
								item.content = item.content.replace(citem, 'xxxx');
							}
						});
					});
				} else {
					this.recordForm.lastSent = true;
					this.total = await getTaskListCount(this.meetingId, this.recordForm);
					this.smsListArr = await getMeetingLianluMsg(this.meetingId, {
						page: 0,
						rows: 100
					});
					if (this.total > 0) {
						arr = await getTaskList(this.meetingId, this.recordForm);
					} else {
						this.loading = false;
						return (this.smsList = []);
					}
				}
				this.getList(arr);
			},
			// 列表处理
			getList(arr) {
				for (let i = 0; i < arr.length; i++) {
					let item = arr[i];
					item.serialNumber = i + 1;
					item.btnLoading = false;
					this.smsTemplateList.forEach((citem) => {
						if (citem.code === item.tmplCode) {
							item.tmplName = citem.name;
						}
					});
				}
				this.isPersonFlag ? (this.personSmsList = arr) : (this.smsList = this.handleTableList(arr));
				console.log("isPersonFlag:", this.isPersonFlag)
				this.loading = false;
			},
			// 重置筛选条件
			resetForm() {
				this.recordForm = {
					content: '',
					keyword: '',
					endTime: '',
					startTime: '',
					roleType: '',
					page: 0,
					rows: 20,
					lastSent: '',
					sendResult: '',
					tmplCode: '',
					username: '',
					userId: '',
					phone: ''
				};
			},
			closeDialog() {
				this.resetForm();
				this.personDialogVisible = this.isPersonFlag = false;
			},
			// 获取用户的所有手机号
			getUserPhones(userId) {
				getUserPhones(this.meetingId, {
						userId
					})
					.then((res) => {
						this.phones = res;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 获取个人详情记录
			getPersonRecord(id) {
				this.resetForm();
				this.loading = this.isPersonFlag = this.personDialogVisible = true;
				this.recordForm.lastSent = null;
				this.recordForm.userId = id;
				this.getUserPhones(id);
				this.getPersonSmsList();
			},
			// 获取个人短信记录列表
			async getPersonSmsList() {
				this.personalTotal = await getSmsRecordCount(this.meetingId, this.recordForm);
				if (this.personalTotal > 0) {
					let personSmsList = await getSmsRecordList(this.meetingId, this.recordForm);
					this.getList(personSmsList);
				} else {
					this.loading = false;
					this.personSmsList = [];
				}
			},
			getExecStrs(str) {
				let reg = /\$\{.+?\}/g;
				let list = [];
				let result = null;
				do {
					result = reg.exec(str);
					result && list.push(result[0]);
				} while (result);
				return list;
			},
			// 获取会议管理人
			getMeetingManager() {
				getMeetingManager(this.meetingId)
					.then((res) => {
						this.managers = [res];
						this.ruleForm.administrator = res.name;
						this.ruleForm.contactNumber = res.phone;
						console.log("ressss", res)
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			editSms(row) {
				this.smsRow = row;
				this.type = row.tmplCode;
				this.contentText = row.contentShow ? row.contentShow : '';
				console.log("paramJson", row)
				if (row.paramJson) {
					let paramJson = JSON.parse(row.paramJson);
					this.ruleForm.administrator = paramJson.contact;
					this.ruleForm.contactNumber = paramJson.contactPhone;
					this.ruleForm.meetingName = paramJson.meetingName;
					this.ruleForm.startTime = Date.parse(paramJson.startTime);
					this.ruleForm.endTime = Date.parse(paramJson.testEndTime);
				} else {
					this.getMeetingManager();
					this.ruleForm.meetingName = this.meetingData[0].name;
					this.ruleForm.startTime = this.meetingData[0].startTime;
					let date = new Date(this.meetingData[0].startTime - 24 * 60 * 60 * 1000);
					date.setHours(22);
					date.setMinutes(0);
					this.ruleForm.endTime = date.getTime();
				}
				this.centerDialogVisible = true;
			},
			// 全部发送
			wholeSend(row) {
				row.btnLoading = true;
				if (row.paramJson) {
					groupSMS(this.meetingId, row.id)
						.then(() => {
							row.btnLoading = false;
							this.$message.success('发送成功');
						})
						.catch((err) => {
							row.btnLoading = false;
							this.$message.error(err.data.message);
						});
				} else {
					this.editSms(row);
					this.$message.error('首次发送请确认参数');
					row.btnLoading = false;
				}
			},
			// 确认发送
			sureEditSms(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.editBtnLoading = true;
						let ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
						if (this.type.includes('SMS_MEETING_TESTING')) {
							delete ruleForm.meeting;
							ruleForm.startTime = moment(ruleForm.startTime).format('YYYY-MM-DD HH:mm');
							ruleForm.endTime = moment(ruleForm.endTime).format('YYYY-MM-DD HH:mm');
							ruleForm.startTime1 = moment(ruleForm.startTime).format('YYYY-MM-DD HH:mm');
						} else {
							delete ruleForm.endTime;
							ruleForm.startTime = moment(ruleForm.startTime).format('YYYY-MM-DD HH:mm');
							ruleForm.startTime1 = moment(ruleForm.startTime).format('YYYY-MM-DD HH:mm');
						}
						console.log("ruleForm", ruleForm)
						// return
						setLianluMsgParamJson(this.meetingId, this.smsRow.id, {
								contact: ruleForm.administrator,
								contactPhone: ruleForm.contactNumber,
								meetingName: ruleForm.meetingName,
								startTime: ruleForm.startTime,
								testEndTime: ruleForm.endTime,
							})
							.then(() => {
								this.$message.success('保存成功');
								this.getSmsList();
								this.templateDialogVisibleClick();
								this.editBtnLoading = this.centerDialogVisible = false;
							})
							.catch((err) => {
								this.editBtnLoading = false;
								this.$message.error(err.data.message);
							});
					}
				});
			}
		}
	};
</script>

<style scoped lang="scss">
	::v-deep .customClass .el-dialog__body {
		padding: 0px 20px 0px 20px !important;
	}

	::v-deep .customClass {
		border-radius: 10px;
	}

	::v-deep .noBorder .el-input__inner {
		color: #3772DE !important;
		border: 0px !important;
		height: 31px !important;
		line-height: 31px !important;
		background-color: #ebf1ff !important;
	}

	::v-deep .el-table__fixed-right::before,
	.el-table__fixed::before {
		height: 0px;
	}

	::v-deep .el-range-editor--small .el-range-input {
		background-color: #F3F4F6;
	}

	::v-deep .meeting-search .el-input--small .el-input__inner {
		background-color: #F3F4F6;
		border: 0px;
	}

	::v-deep .meeting-search .el-range-editor--small.el-input__inner {
		background-color: #F3F4F6;
		border: 0px;
	}

	.sms-manager {
		.meeting-search {
			padding: 0 10px;
			box-sizing: border-box;
		}

		.el-form-item {
			margin-right: 20px;
		}

		::v-deep .el-tabs__nav-scroll {
			padding-left: 15px;
			box-sizing: border-box;
		}

		.refresh {
			color: red;
			font-size: 12px;
			// text-align: right;
			// margin: 0 0 10px 20px;
		}

		.sms-table {
			::v-deep .el-table__row {
				::v-deep .cell {
					display: -webkit-box;
					-webkit-line-clamp: 2;
					overflow: hidden;
					text-overflow: ellipsis;
					-webkit-box-orient: vertical;
				}
			}

			::v-deep .is-leaf {
				// background: #c22929 !important;
				// background: -webkit-linear-gradient(top, #cc0001 , #de4d2a, #f17b2e) !important;
				// background: -webkit-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
				// background: -moz-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
				// background: -o-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
				// background: -ms-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
				// background: linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
				// color: #fff;

				text-align: center;
			}
		}

		.el-table .el-button.btn {
			color: #2c7bbc;

			::v-deep span:hover {
				border-bottom: 1px solid #2c7bbc;
			}
		}
	}

	.chatBox {
		position: relative;
		margin: 12px;
		padding: 10px;
		word-break: break-all;
		background: #E8F0FF;
		border: 1px solid #E8F0FF;
		border-radius: 5px;
		max-width: 100%;
	}

	.chatBox-left::before {
		content: '';
		position: absolute;
		width: 0;
		height: 0;
		left: -20px;
		top: 20px;
		border: 10px solid;
		border-color: transparent #E8F0FF transparent transparent;
	}

	.balloon-left {
		position: relative;
		display: inline-block;
		padding: 0 5px;
		width: auto;
		min-width: 100px;
		height: 24px;
		line-height: 24px;
		text-align: center;
		background: #FFE8BA;
		z-index: 0;
		border-radius: 3px;
		font-size: 12px;
		color: #BA6F13;
		font-weight: 700;
	}

	.balloon-left:before {
		border-style: solid;
		border-width: 6px 6px 6px 0;
		border-color: transparent #FFE8BA transparent transparent;
		content: "";
		position: absolute;
		top: 50%;
		left: -6px;
		margin-top: -7px;
		display: block;
		width: 0px;
		height: 0px;
		z-index: 0;
	}

	.balloon-left:after {
		border-style: solid;
		border-width: 11px 11px 11px 0;
		border-color: transparent #FFFFFF transparent transparent;
		content: "";
		position: absolute;
		top: 50%;
		left: -12px;
		margin-top: -10px;
		display: block;
		width: 0px;
		height: 0px;
		z-index: -1;
	}
</style>
